<mat-select
    [attr.cy-select]="ngControl.name"
    [(value)]="value"
    [attr.data-testid]="id"
    #matSelect
    (openedChange)="handleSelection($event)">
    @if (value && value.tenantId) {
        <mat-select-trigger>
            <div class="container-trigger-select-tenant">
                <mat-icon fontSet="material-icons-outlined" [svgIcon]="value.tenantId">{{value.tenantId}}</mat-icon>
                <span>{{value.tenantName}}</span>
            </div>
        </mat-select-trigger>
    }
    @for (tenant of lstTenants; track tenant.tenantId) {
        <mat-option [attr.data-testid]="idOptionsPrefix+tenant.tenantId" [value]="tenant"><mat-icon fontSet="material-icons-outlined" [svgIcon]="tenant.tenantId">{{tenant.tenantId}}</mat-icon>{{ tenant.tenantName }}</mat-option>
    }
</mat-select>